import { AbstractControl, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function UrlValidator(control: UntypedFormControl) {
  // tslint:disable-next-line: max-line-length
  return !control.value || /\b((http|https):\/\/)[^\s()<>]+(?:\([\w\d]+\)|([^[:punct:]\s]|\/?))/
    .test(control.value) ? null : { 'url': true };
}

export function MaxMinValidator(control) {
  const { min, max} = control.controls;
    // if (!min.value && !max.value) {
    //   return {};
    // }
    if (min.value && !max.value) {
      return { fieldMatch: { message: 'Enter maximum value' } };
    }
    if (!min.value && max.value) {
      return { fieldMatch: { message: 'Enter minimum value' } };
    }
    if (Number(min.value) > Number(max.value)){
      return { fieldMatch: { message: 'Minimum value cannot be greater than maximum' } };
    }
    return null;
}
